import React from 'react'

interface UserBadgeProps {
  name: string
  color: string
  /** Small circular form used in avatar stacks. */
  size?: 'sm' | 'md'
  /** Renders the badge with an outline ring for "this is you". */
  self?: boolean
  title?: string
}

/**
 * Colour-coded avatar pill for a single peer. We don't have real
 * avatars yet, so we render the user's first letter inside a
 * circle that carries their presence colour. Stacked in the
 * header to show everyone currently in the room.
 */
export const UserBadge: React.FC<UserBadgeProps> = ({
  name,
  color,
  size = 'sm',
  self,
  title,
}) => {
  const initial = (name || '?').trim().charAt(0).toUpperCase() || '?'
  const sizePx = size === 'md' ? 28 : 22
  return (
    <div
      title={title ?? name}
      aria-label={`${name}${self ? ' (you)' : ''}`}
      className="inline-flex items-center justify-center rounded-full text-[10px] font-mono font-bold text-white shadow"
      style={{
        width: sizePx,
        height: sizePx,
        backgroundColor: color,
        outline: self ? '2px solid var(--accent, #fff)' : 'none',
        outlineOffset: 1,
      }}
    >
      {initial}
    </div>
  )
}
